export default __webpack_public_path__ + "static/cafe_36083-927217892d3ca3037f38cc309f9a2488.png";